export default "__VITE_ASSET__e367d522__"